export default "__VITE_ASSET__DrfEMYaE__"